import { spawn } from 'redux-saga/effects';

import { poolListSagas } from './listModule';

export default function* poolSaga() {
	yield spawn(poolListSagas);
}
